
import { DocumentManager } from './document-upload/DocumentManager';
import type { Application } from '@/types/database.types';

interface DocumentUploadProps {
  data: Partial<Application>;
  onSave: (data: Partial<Application>) => Promise<void>;
}

export const DocumentUpload = (props: DocumentUploadProps) => {
  return <DocumentManager {...props} />;
};
